import _ from 'underscore';
import { Mode } from './mode';
import { ILayoutConfig } from './types';

// these components have logic themselves to dynamically change layout
const dynamicComponents: ILayoutConfig = {
  topBanner: {
    mode: Mode.Collapsed,
  },
  promotionBanner: {
    mode: Mode.Collapsed,
  },
  copilot: {
    mode: Mode.Collapsed,
  },
};

const staticComponents: ILayoutConfig = {
  header: {
    mode: Mode.Collapsed,
  },
  panelContainer: {
    mode: Mode.Collapsed,
  },
  nav: {
    mode: Mode.Expanded,
  },
  scopePanel: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Expanded,
  },
  status: {
    mode: Mode.Expanded,
  },
  tab: {
    mode: Mode.Collapsed,
  },
  messageBar: {
    mode: Mode.Hidden,
  },
  subTab: {
    mode: Mode.Hidden,
  },
  content: {
    mode: Mode.Expanded,
    filterBar: {
      visible: false,
    },
  },
  overlay: {
    mode: Mode.Hidden,
  },
};

const base: ILayoutConfig = { ...staticComponents, ...dynamicComponents };

const immersive: ILayoutConfig = _.defaults({
  nav: {
    mode: Mode.Collapsed,
  },
}, staticComponents);

const fullScreen: ILayoutConfig = _.defaults({
  nav: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Hidden,
  },
  status: {
    mode: Mode.Hidden,
  },
  tab: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const mainContentWithTab: ILayoutConfig = _.defaults({
  nav: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Hidden,
  },
  status: {
    mode: Mode.Hidden,
  },
  header: {
    mode: Mode.Hidden,
  },
  topBanner: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const mainContentWithStatus: ILayoutConfig = _.defaults({
  header: {
    mode: Mode.Hidden,
  },
  topBanner: {
    mode: Mode.Hidden,
  },
  nav: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Hidden,
  },
  tab: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const mainContentWithStatusAndTab: ILayoutConfig = _.defaults({
  header: {
    mode: Mode.Hidden,
  },
  topBanner: {
    mode: Mode.Hidden,
  },
  nav: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const fullScreenWithNavRefresh: ILayoutConfig = _.defaults({
  status: {
    mode: Mode.Hidden,
  },
  tab: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const withoutDate: ILayoutConfig = {
  tab: {
    mode: Mode.Collapsed,
    showDatePicker: false,
  },
};

const withoutStatus: ILayoutConfig = {
  status: {
    mode: Mode.Hidden,
  },
};

const withDisabledDate: ILayoutConfig = {
  tab: {
    mode: Mode.Collapsed,
    showDisabledDatePicker: true,
    showDatePicker: false,
  },
};

const withHistoryButton: ILayoutConfig = {
  tab: {
    mode: Mode.Collapsed,
    showDatePicker: false,
    showHistoryButton: true,
  },
};

const dateWithoutCompare: ILayoutConfig = {
  tab: {
    mode: Mode.Collapsed,
    disableCompare: true,
  },
};

const fullScreenWithSummaryBar: ILayoutConfig = _.defaults({
  nav: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Hidden,
  },
  tab: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const fullScreenWithSummaryBarWithNavRefresh: ILayoutConfig = _.defaults({
  tab: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const fullScreenWithSummaryBarAndTab: ILayoutConfig = _.defaults({
  nav: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const fullScreenWithTab: ILayoutConfig = _.defaults({
  nav: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Hidden,
  },
  status: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const withoutNav: ILayoutConfig = _.defaults({
  nav: {
    mode: Mode.Hidden,
  },
}, staticComponents);

const accountSummary: ILayoutConfig = {
  nav: {
    mode: Mode.Hidden,
  },
};

const accountSummaryWithoutDate: ILayoutConfig = {
  ...accountSummary,
  ...withoutDate,
};

const withMenuOnly: ILayoutConfig = {
  nav: {
    mode: Mode.Hidden,
  },
  tab: {
    mode: Mode.Hidden,
  },
};

const withoutMenu: ILayoutConfig = {
  menu: {
    mode: Mode.Hidden,
  },
};

const withSingleTab: ILayoutConfig = {
  nav: {
    mode: Mode.Hidden,
  },
  tab: {
    singleTabMode: true,
  },
};

const withCollapsedMenuOnly: ILayoutConfig = _.defaults({
  nav: {
    // Main menu
    mode: Mode.Collapsed,
  },
  menu: {
    // Page menu
    mode: Mode.Hidden,
  },
  status: {
    // Top bar containing 'Back' button and page title
    mode: Mode.Hidden,
  },
  tab: {
    // Horizontal tabs on top of page bearing page titles
    mode: Mode.Hidden,
    showDatePicker: false,
  },
}, staticComponents);

const withCollapsedMenuAndNav: ILayoutConfig = _.defaults({
  nav: {
    // Main menu
    mode: Mode.Collapsed,
  },
  menu: {
    // Page menu
    mode: Mode.Expanded,
  },
  status: {
    // Top bar containing 'Back' button and page title
    mode: Mode.Expanded,
  },
  tab: {
    // Horizontal tabs on top of page bearing page titles
    mode: Mode.Hidden,
    showDatePicker: false,
  },
}, staticComponents);

const withTabAndSubTab: ILayoutConfig = {
  tab: {
    mode: Mode.Collapsed,
  },
  subTab: {
    mode: Mode.Expanded,
  },
};

const signupScreen: ILayoutConfig = _.defaults({
  header: {
    mode: Mode.Expanded,
  },
  nav: {
    mode: Mode.Hidden,
  },
  menu: {
    mode: Mode.Hidden,
  },
  status: {
    mode: Mode.Hidden,
  },
  tab: {
    mode: Mode.Hidden,
  },
}, base);

const withMessageBar: ILayoutConfig = _.defaults({
  messageBar: {
    mode: Mode.Expanded,
  },
}, base);

const withInlineStatus: ILayoutConfig = {
  status: {
    mode: Mode.Expanded,
    inlineStatus: true,
  },
};

const withFluentFilterBar: ILayoutConfig = {
  content: {
    filterBar: {
      visible: true,
    },
  },
};

const withFluentFilterBarDatePickerOnly: ILayoutConfig = {
  content: {
    filterBar: {
      visible: true,
      datePickerOnly: true,
    },
  },
};

const withFluentFilterBarNoDatePicker: ILayoutConfig = {
  content: {
    filterBar: {
      visible: true,
      hideDatePicker: true,
    },
  },
};

export const layoutConfigs = {
  default: base,
  staticComponents,
  immersive,
  fullScreen,
  withoutDate,
  withoutStatus,
  withDisabledDate,
  withoutNav,
  withSingleTab,
  fullScreenWithTab,
  fullScreenWithSummaryBar,
  fullScreenWithSummaryBarAndTab,
  accountSummary,
  accountSummaryWithoutDate,
  withMenuOnly,
  withCollapsedMenuOnly,
  withCollapsedMenuAndNav,
  withoutMenu,
  dateWithoutCompare,
  withTabAndSubTab,
  withHistoryButton,
  signupScreen,
  fullScreenWithNavRefresh,
  fullScreenWithSummaryBarWithNavRefresh,
  mainContentWithTab,
  mainContentWithStatus,
  withMessageBar,
  mainContentWithStatusAndTab,
  withInlineStatus,
  withFluentFilterBar,
  withFluentFilterBarDatePickerOnly,
  withFluentFilterBarNoDatePicker,
};
